import { React, ajax, clickOn, _n } from 'pexui';
import { DocUploadService } from '../../services/docuploadsvc';
import { flow } from '../../models/flow';
import { Button, RemoveButton } from '../comps/uicomps';
import { startBusy, stopBusy } from '../comps/busy';
import * as utils from '../../utilities/utils';
import { track } from '../../utilities/track';
/**
 * Decides if the file size exceeds limit
 * @param {*} size  size of file in bytes
 * @param {number} limit  limit of file in MB
 * @returns {boolean}
 */
function fileSizeExceedsLimit(size, limit) {
    if (typeof size !== 'undefined') {
        const s = parseInt(size);
        return s > limit * 1048576;
    }
    return false;
}

/**
 *
 * @param file
 *
 * Do any prechecks if possible but the server side code will do the final check
 * can not prevent everything from the client in case there is some way to bypass these
 */
function checkForFileErrors(node, file, on_error) {
    // clean the previous error messages.
    node.messages = [];

    let errors = false;

    const addError = errorKey => {
        // '!' means a user-facing message, don't convert it again.
        on_error('!' + _n(errorKey), errorKey);
        errors = true;
    };

    //total file size error
    const totalSize = node.files.reduce((totalFileSize, f) => {
        return (totalFileSize += f.size);
    }, file.size);
    if (fileSizeExceedsLimit(totalSize, 30)) {
        flow.lastError = '50320';
        addError('error.50320.message');
    }
    //duplicate file error
    let duplicate = node.files.some(f => f.originalName === file.originalName);
    if (duplicate) {
        flow.lastError = 'dupfile';
        addError('error.duplicate.message');
    }
    //file size error
    if (fileSizeExceedsLimit(file.size, 10)) {
        flow.lastError = '50300';
        addError('error.50300.message');
    }

    return errors;
}

function uploadAFile(node, file, params, on_success, on_error) {
    flow.lastChannel = 'DOCUPLOAD';

    if (!checkForFileErrors(node, file, on_error)) {
        DocUploadService.upload(file, params, node.code)
            .then(resp => {
                stopBusy();
                const respObj = resp.obj;
                flow.docUploadTids[node.code] = respObj.docupld_tid

                if (typeof on_success === 'function') {
                    on_success(resp.file, respObj);
                }
            })
            .catch(err => {
                stopBusy();

                if (typeof on_error === 'function') {
                    on_error(err);
                }
            });
    } else {
        stopBusy();
    }
}

function removeAFile(files, file, on_change, on_error, code, node) {
    flow.lastChannel = 'DOCUPLOAD';
    const req = flow.req;

    DocUploadService.removeFile({
        transaction_id: req.transaction_id,
        originator_id: req.originator_id,
        docupld_request_id: req.transaction_id,
        market: req.market,
        account_number: req.document_data.process_control_number || null,
        docupld_fid: file.fid,
        docupld_tid: flow.docUploadTids[code] || '',
        docupld_token: flow.docupld_token || '',
        customer_id: node.account.customer_id || '',
        organization_id: node.account.organization_id || '',
        offer_details_code: req.document_data.offer_details_code,
        document_type: node.widgetOption ? node.widgetOption.document_type : '',
    }, code).then(
        resp => {
            stopBusy();

            utils.deleteArray(files, f => f.fid === file.fid);

            if (typeof on_change === 'function') {
                on_change();
            }
        },
        err => {
            stopBusy();

            if (typeof on_error === 'function') {
                on_error(err);
            }
        }
    );
}

export function FileButton({
    node,
    id,
    className,
    label,
    style,
    params,
    busyZone,
    onUploaded,
    onError,
}) {
    const btnIdFile = 'infw_btn_file_' + utils.randomString(8);
    const buttonRegualr = (
        <Button
            id={id}
            className={className}
            label={label}
            style={style}
            busyZone={busyZone}
            onClick={() => {
                clickOn(btnIdFile);
            }}
        />
    );

    return (
        <span>
            {buttonRegualr}
            <input
                type="file"
                id={btnIdFile}
                style={{ display: 'none' }}
                onChange={evt => {
                    startBusy(buttonRegualr);
                    uploadAFile(
                        node,
                        evt.target.files.length > 0
                            ? evt.target.files[0] // globals.onFilePicker is for unit test
                            : typeof globals.onFilePicker === 'function'
                              ? globals.onFilePicker.call(evt.target)
                              : null,
                        params,
                        onUploaded,
                        onError
                    );
                }}
            />
        </span>
    );
}

FileButton.propTypes = {
    label: React.PropTypes.string.isRequired,
    className: React.PropTypes.string,
    style: React.PropTypes.object,
    busyZone: React.PropTypes.string,
    onUploaded: React.PropTypes.func,
    onError: React.PropTypes.func,
};

export const FilesList = ({ node, withRemove, on_change, on_error }) => {
    const { code, files } = node;
    if (files) {
        return (
            <table style={{ width: '100%' }}>
                {files.map(file => {
                    var icon = false;
                    if (file.type === 'file') {
                        if (/\.pdf$/.test(file.originalName)) {
                            icon = <span className="dls-icon-pdf" />;
                        } else {
                            icon = <span className="dls-icon-document" />;
                        }
                    }
                    return (
                        <tr className="border-tb">
                            <td className="text-align-left">
                                {icon}
                                {file.originalName}
                            </td>
                            <td className="text-align-right infw-file-list">
                                {file.completedTime ? (
                                    <span>
                                        <span
                                            className={
                                                file.type === 'info' ||
                                                file.successCode ===
                                                    'INGESTED' ? (
                                                    'infw-icon-success'
                                                ) : (
                                                    'infw-icon-error'
                                                )
                                            }
                                        />
                                        <span>
                                            {file.type === 'info' ? (
                                                _n('completed_on')
                                            ) : file.successCode ===
                                            'INGESTED' ? (
                                                _n('uploaded_on')
                                            ) : (
                                                file.message
                                            )}
                                        </span>
                                        <div className="infw-file-message text-align-center">
                                            {_n('upload_file_message')}
                                        </div>
                                    </span>
                                ) : (
                                    <span>
                                        {withRemove ? (
                                            <RemoveButton
                                                icon="infw-icon-remove"
                                                label={_n('link_removefile.label')}
                                                busyZone="widget"
                                                onClick={() => {
                                                    removeAFile(
                                                        files,
                                                        file,
                                                        on_change,
                                                        on_error,
                                                        code,
                                                        node
                                                    );
                                                }}
                                            />
                                        ) : (
                                            false
                                        )}
                                    </span>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </table>
        );
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./application/src/views/docupload/files.jsx